var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0185549 9.0097C0.0183741 7.59325 0.352518 6.19676 0.993812 4.93381C1.63511 3.67085 2.56544 2.57709 3.70915 1.74148C4.85286 0.905874 6.17765 0.352013 7.57577 0.124944C8.9739 -0.102125 10.4059 0.00401118 11.7553 0.43472C13.1046 0.865428 14.3333 1.60855 15.3413 2.60364C16.3493 3.59873 17.1082 4.81769 17.5563 6.16139C18.0044 7.50509 18.129 8.93558 17.92 10.3365C17.711 11.7375 17.1743 13.0693 16.3536 14.2237L23.5791 21.4492C23.8523 21.7321 24.0035 22.111 24.0001 22.5043C23.9966 22.8976 23.8389 23.2738 23.5608 23.5519C23.2827 23.83 22.9065 23.9878 22.5132 23.9912C22.1199 23.9946 21.741 23.8434 21.4581 23.5702L14.2341 16.3462C12.8876 17.3036 11.3036 17.8719 9.65557 17.9889C8.00756 18.1058 6.35916 17.7669 4.891 17.0092C3.42285 16.2514 2.19158 15.1042 1.33214 13.6932C0.472695 12.2822 0.0182336 10.6618 0.0185549 9.0097ZM9.01855 3.00969C7.42726 3.00969 5.90113 3.64184 4.77591 4.76705C3.6507 5.89227 3.01855 7.4184 3.01855 9.0097C3.01855 10.601 3.6507 12.1271 4.77591 13.2523C5.90113 14.3776 7.42726 15.0097 9.01855 15.0097C10.6099 15.0097 12.136 14.3776 13.2612 13.2523C14.3864 12.1271 15.0186 10.601 15.0186 9.0097C15.0186 7.4184 14.3864 5.89227 13.2612 4.76705C12.136 3.64184 10.6099 3.00969 9.01855 3.00969Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f39afaddf34d3405ab55289fa633b7d1.svg";
export { ForwardRef as ReactComponent };